import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

import { useAppStore } from '@/store'
import { storeToRefs } from 'pinia'
import { useRoute, useRouter } from 'vue-router'
import { ref } from 'vue'
import { Menu } from '@/store/modules/app/app.interface'


export default /*#__PURE__*/_defineComponent({
  __name: 'menu',
  emits: ['push'],
  setup(__props, { emit: __emit }) {

const app = useAppStore()
const router = useRouter()
const route = useRoute()
const { menuList, sidebarStatus, mobileScreenMode } = storeToRefs(app)

const emit = __emit

const onClickMenuItem = (key: string) => {
  emit('push')
  if (key === '/ai-helper' || key.endsWith('/ai-helper')) {
    const href = router.resolve('/ai-helper').href
    window.open(href, '_blank', 'noopener')
    return
  }
  if (key.startsWith('http')) {
    router.push({
      path: 'extend-page',
      query: {
        url: encodeURIComponent(key)
      }
    })
  } else {
    router.push(key)
  }
}

const currentSelectedMenu = ref<string[]>([])
function getCurrentMenu (list: Menu[]) {
  list.forEach(element => {
    if (element.children?.length) {
      getCurrentMenu(element.children)
    } else if (element.url === route.fullPath) {
      currentSelectedMenu.value.push(element.url)
    }
  })
}
getCurrentMenu(menuList.value)

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createBlock(_component_a_menu, {
    "default-selected-keys": currentSelectedMenu.value,
    onMenuItemClick: onClickMenuItem,
    "auto-scroll-into-view": "",
    "auto-open-selected": ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (menu) => {
        return (_openBlock(), _createElementBlock("div", {
          key: menu.url
        }, [
          (!menu.children || menu.children.length === 0)
            ? (_openBlock(), _createBlock(_component_a_menu_item, {
                key: menu.url
              }, _createSlots({
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(menu.name), 1)
                ]),
                _: 2
              }, [
                (menu.icon)
                  ? {
                      name: "icon",
                      fn: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(menu.icon)))
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1024))
            : (_openBlock(), _createBlock(_component_a_sub_menu, {
                key: menu.url + 'child'
              }, _createSlots({
                title: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(menu.name), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, (child) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: child.url
                    }, [
                      (!child.children || child.children.length === 0)
                        ? (_openBlock(), _createBlock(_component_a_menu_item, {
                            key: child.url
                          }, _createSlots({
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(child.name), 1)
                            ]),
                            _: 2
                          }, [
                            (child.icon)
                              ? {
                                  name: "icon",
                                  fn: _withCtx(() => [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(child.icon)))
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1024))
                        : (_openBlock(), _createBlock(_component_a_sub_menu, {
                            key: child.url + 'child'
                          }, _createSlots({
                            title: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(child.name), 1)
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (item) => {
                                return (_openBlock(), _createBlock(_component_a_menu_item, {
                                  key: item.url
                                }, _createSlots({
                                  default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, [
                                  (item.icon)
                                    ? {
                                        name: "icon",
                                        fn: _withCtx(() => [
                                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
                                        ]),
                                        key: "0"
                                      }
                                    : undefined
                                ]), 1024))
                              }), 128))
                            ]),
                            _: 2
                          }, [
                            (child.icon)
                              ? {
                                  name: "icon",
                                  fn: _withCtx(() => [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(child.icon)))
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1024))
                    ]))
                  }), 128))
                ]),
                _: 2
              }, [
                (menu.icon)
                  ? {
                      name: "icon",
                      fn: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(menu.icon)))
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1024))
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["default-selected-keys"]))
}
}

})